/**
 * 生成頁選項的 sessionStorage 持久化
 *
 * 讓使用者在跳去登入頁再回來、或重新整理頁面時，先前填寫的選項不會遺失。
 */

const GENERATION_SELECTIONS_STORAGE_KEY = "generation_selections";

export interface PersistedGenerationSelections {
  selectedEdu: string | null;
  selectedSubject: string | null;
  selectedVolume: string | null;
  selectedChapter: string | null;
  selectedSubChapter: string | null;
  customText: string;
}

/**
 * 從 sessionStorage 讀出先前保存的選項
 */
export const readPersistedSelections =
  (): PersistedGenerationSelections | null => {
    try {
      const raw = sessionStorage.getItem(GENERATION_SELECTIONS_STORAGE_KEY);

      if (!raw) {
        return null;
      }

      return JSON.parse(raw) as PersistedGenerationSelections;
    } catch (error) {
      console.error("readPersistedSelections error:", error);
      return null;
    }
  };

/**
 * 將目前選項寫回 sessionStorage
 */
export const writePersistedSelections = (
  selections: PersistedGenerationSelections
) => {
  try {
    sessionStorage.setItem(
      GENERATION_SELECTIONS_STORAGE_KEY,
      JSON.stringify(selections)
    );
  } catch (error) {
    console.error("writePersistedSelections error:", error);
  }
};
